module.exports = __webpack_public_path__ + "img/logo-viajabara.6add3a63.png";